import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class SharedUtilService {

  constructor(private modalService: NgbModal) { }

  openConfirmDialog(relayConfirmMessage, relayConfirmCancel?): Promise<any> {
    const modalRef = this.modalService.open(ConfirmDialogComponent,
      { ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        windowClass: 'confirm-modal',
        centered: true,
        size: 'sm'
      });

    const data = {
      relayConfirmMsg: relayConfirmMessage,
      relayConfirmCancel
    };

    modalRef.componentInstance.fromParent = data;
    return modalRef.result;
  }

  goToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}
